import { useState, useCallback } from 'react';

interface ShareData {
  title: string;
  text: string;
}

export const useShareVoucher = () => {
  const [isCopied, setIsCopied] = useState(false);

  const copy = useCallback(async (text: string) => {
    try {
      await navigator.clipboard.writeText(text);
      setIsCopied(true);
      setTimeout(() => setIsCopied(false), 2000);
    } catch {
      // Silent fail
    }
  }, []);

  const share = useCallback(
    async (shareData: ShareData, fallbackText: string) => {
      if (!navigator.share) {
        copy(fallbackText);
        return;
      }

      if (navigator.canShare && !navigator.canShare(shareData)) {
        copy(fallbackText);
        return;
      }

      try {
        await navigator.share(shareData);
      } catch (error) {
        if (error instanceof Error && error.name !== 'AbortError') {
          copy(fallbackText);
        }
      }
    },
    [copy],
  );

  return { isCopied, copy, share };
};
